import React, { useState, useEffect } from 'react'
//import { useHistory } from 'react-router'
import { FormattedMessage } from 'react-intl';
import { Arrow as ArrowRight, ImageAmorimWise, ImageWicanders } from '../../../assets'
import { Container, 
        AmorimWise, 
        Wicanders, 
        ContainerContent, 
        Text,
        BigText,
        Arrow,
        ButtonStartVisit } from './index.styled'

function SplashSplitMobile({ active, handleScreenActive }) {
  //const history = useHistory()
  const [ amorimClass, setAmorimClass ] = useState('');
  const [ wicandersClass, setWicandersClass ] = useState('');

  const handleClickAmorin = () => {
    console.log("click Amorin Wise");
   // history.replace("/wise")
   window.open('https://showroom.amorimwise.com', '_blank')
  }

  const handleClickWicanders = () => {
    //history.replace("/wicanders")
    window.open('https://showroom.wicanders.com', '_blank')
  }
  
  const handleChangeAmorim = () => {
    if(active === 'amorin_wise') {
      handleScreenActive('')
    } else {
      handleScreenActive('amorin_wise')
    }
  }

  const handleChangeWicanders = () => {
    if(active === 'wicanders') {
      handleScreenActive('')
    } else {
      handleScreenActive('wicanders')
    }
  }

  useEffect(() => {
    switch(active) {
      case 'amorin_wise':
        setAmorimClass('stretch');
        setWicandersClass('shrink');
        break;
      case 'wicanders':
        setWicandersClass('stretch');
        setAmorimClass('shrink');
        break;
      default:
        setAmorimClass('');
        setWicandersClass('');
    }
    if(active === '') {
      setAmorimClass('');
      setWicandersClass('');
    }
  }, [active])

  return (
    <Container>
      <AmorimWise 
        onClick={() => handleChangeAmorim()}
        className={amorimClass}
      >
        <ContainerContent>
          <Text><FormattedMessage id="splash.smart-choice" /></Text>
          <Text><FormattedMessage id="splash.amazing-sensations" /></Text>
          <BigText src={ImageAmorimWise} width={250}/>
          <ButtonStartVisit onClick={handleClickAmorin}>
            <Text className="smaller-text"><FormattedMessage id="splash.start-visit" /></Text>
            <Arrow background={ArrowRight}/>
          </ButtonStartVisit>
        </ContainerContent>
      </AmorimWise>
      <Wicanders 
        onClick={() => handleChangeWicanders()}
        className={wicandersClass}
        >
        <ContainerContent className="content-right">
          <Text className="text-right"><FormattedMessage id="splash.everyday-confort" /></Text>
          <Text className="text-right"><FormattedMessage id="splash.lifetime-perfomance" /></Text>
          <BigText src={ImageWicanders} width={216} className="pos-right"/>
          <ButtonStartVisit onClick={handleClickWicanders} className="content-right">
            <Text className="smaller-text"><FormattedMessage id="splash.start-visit" /></Text>
            <Arrow background={ArrowRight} className="content-right"/>
          </ButtonStartVisit>
        </ContainerContent>
      </Wicanders>
    </Container>
  )
}

export default SplashSplitMobile;